import { container } from "tsyringe";
import { PageAttributesExtractor } from "../shared/PageAttributesExtractor";
import { DotCaPageAttributesExtractor } from "./DotCaPageAttributesExtractor";
import { ServiceTokens } from "../shared/ServiceTokens";
import { SiteRules } from "../shared/SiteRules";
import { DotCaSiteRules } from "./DotCaSiteRules";
import { UserDataLayerAdapterFactory } from "../shared/UserDataLayerAdapterFactory";
import { DotCaUserDataLayerAdapterFactory } from "./DotCaUserDataLayerAdapterFactory";
import { SiteSettings } from "../shared/SiteSettings";
import { DotCaSiteSettings } from "./DotCaSiteSettings";
import { GeoIpCoordinatesService } from "../shared/geoLocation/GeoIpCoordinatesService";
import { GeoCoordinatesService } from "../shared/geoLocation/GeoCoordinatesService";
import { DotCaEngagementService } from "./DotCaEngagementService";

/**
 * This function is used to register DotCa-specific implementations to
 * TSyringe's container.
 */
export function registerDotCaServices(): void {
  container.register<GeoCoordinatesService>(ServiceTokens.GeoCoordinatesService, {
    useClass: GeoIpCoordinatesService,
  });
  container.register<PageAttributesExtractor>(ServiceTokens.PageAttributesExtractor, {
    useClass: DotCaPageAttributesExtractor,
  });
  container.register<SiteSettings>(ServiceTokens.SiteSettings, {
    useClass: DotCaSiteSettings,
  });
  container.register<SiteRules>(SiteRules, {
    useClass: DotCaSiteRules,
  });
  container.register<UserDataLayerAdapterFactory>(ServiceTokens.UserDataLayerAdapterFactory, {
    useClass: DotCaUserDataLayerAdapterFactory,
  });
  container.register<DotCaEngagementService>(DotCaEngagementService, {
    useClass: DotCaEngagementService,
  });
}
